import { CLAIMS_LISTING_INIT_LOADING, CLAIMS_LISTING_INIT_SUCCESS, CLAIMS_LISTING_INIT_FAIL } from '@/store/types'

export const list = {
  [CLAIMS_LISTING_INIT_LOADING](state) {
    state.listing.init = 0
    state.listing.initErr = []
    state.listing.menu = {}
  },
  [CLAIMS_LISTING_INIT_SUCCESS](state, data) {
    state.listing.init = 1
    state.listing.initErr = []
    state.listing.menu = data.menu
  },
  [CLAIMS_LISTING_INIT_FAIL](state, error) {
    state.listing.init = 2
    state.listing.initErr = error
    state.listing.menu = {}
  }
}
